import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@y42/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class ImageUploadService {
  constructor(protected http: HttpClient) {}

  private readonly url = `${environment.url.frontend_storage_api}/upload`;

  uploadImage(formData: FormData): Observable<{ url: string }> {
    return this.http.post(`${this.url}`, formData).pipe(map(mapResponseFunction));
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function mapResponseFunction(res: Record<string, any>) {
  return res?.['data'] || res;
}
